<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Profil </h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-card no-body> <!-- <b-card no-body>  -->
                   <b-overlay :show="loading" rounded="sm" opacity="0.50 " variant="white">
                        <b-tabs active-nav-item-class="font-weight-bold" content-class="mt-3" fill>

    <!-- ##################################################################################################################################################################### -->       
                            <b-tab title="Informations Personnelles" active class="font-weight-bold" @click="clearPassword()">
                                <div class="col-md-10 m-auto" >
    <!-- * * * * * * * * * * * * * * * * * * * * * -->            
                                    <b-alert
                                        :show="alert.profile&&alert.dismissCountDown"
                                        dismissible
                                        :variant="error.profile? 'danger': 'success'"
                                        @dismissed="[alert.dismissCountDown=0 , alert.profile=false ,error.profile = false ]"
                                        @dismiss-count-down="countDownChanged">
                                        <div class="text-center m-auto"  :class="error.profile? 'text-danger': 'text-success'">
                                            <span class="lead" >
                                                <span v-if="error.profile">{{error.text}}</span>
                                                <span v-else-if="error.profile==false">Votre Profil a été modifié avec succès </span>
                                            </span>   
                                            <br> <hr> cette alerte disparaîtra après {{alert.dismissCountDown}} secondes 
                                        </div>
                                    </b-alert> 
    <!-- * * * * * * * * * * * * * * * * * * * * * -->
                                <div class="col-md-7 fixed-top m-auto mrg-top-70">            
                                     
                                
                                <b-alert
                                        :show="alert.validerEmail&&alert.dismissCountDown"
                                        dismissible
                                        :variant="error.validerEmail? 'danger': 'success'"
                                        @dismissed="[alert.dismissCountDown=0 , alert.validerEmail=false ,error.validerEmail = false ]"
                                        @dismiss-count-down="countDownChanged">
                                        <div class="text-center m-auto"  :class="error.validerEmail? 'text-danger': 'text-success'">
                                            <span class="lead" >
                                                <span v-if="error.validerEmail">{{error.text}}</span>
                                                <span v-else-if="error.validerEmail==false&&!alreadyValid">
                                                    Nous avons envoyé un lien pour valider cette adresse email :<br> {{email}}
                                                </span>
                                                <span v-else-if="error.validerEmail==false&&alreadyValid">
                                                        cette adresse mail {{email}} est déjà valide.
                                                </span>
                                                
                                            </span>   
                                            <br> <hr> cette alerte disparaîtra après {{alert.dismissCountDown}} secondes 
                                        </div>
                                    </b-alert>
                                </div>
                    <!-- * * * * * * * * * * * * * * * * * * * * * -->  
                                    <div class="row text-right">
                                        <div class="col-md-12">
                                            <button class="btn " :class="readonly ? 'btn-info' : 'btn-secondary'" 
                                            @click="Cancel()"
                                            :placeholder="readonly? 'C': ''"> 
                                                Editer
                                            </button>
                                        </div>
                                    </div>
                    <!-- * * * * * * * * * * * * * * * * * * * * * -->
                                    <form @submit.prevent="update">
                                        <div class="row">
                                            <div class="col-md-12  overflow-auto">
                                                <table id="profile" class="table table-lg table-striped text-center font-weight-normal">
                                                    <tr> 
                                                        <th class="align-middle"> Intitulé <span class="text-danger" v-show="!readonly">*</span></th> 
                                                        <td v-if="readonly" class="align-middle"> {{this.title}}</td>
                                                        <td v-else class="align-middle "> <select v-model="title" class="form-control custom-select border-color" required
                                                                        :disabled="readonly">
                                                                    <option disabled value="">Choisir...</option>
                                                                    <option>Mme.</option>
                                                                    <option>M.</option>
                                                                    <option>CUMA</option>
                                                                    <option>EARL</option>
                                                                    <option>SCEA</option>
                                                                    <option>GAEC</option>
                                                                    <option>SAS</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    <tr> 
                                                        <th class="align-middle"> Nom <span class="text-danger" v-show="!readonly">*</span></th> 
                                                        <td v-if="readonly" class="align-middle"> {{this.lastname}}</td> 
                                                        <td v-else class="align-middle"> <input v-model="lastname" 
                                                                        type="text" name="Nom" @keypress="check_input($event)"
                                                                        placeholder="Entrer le nom de famille"
                                                                        class="form-control border-color"
                                                                        minlength="1" maxlength="255"
                                                                        required  
                                                                        :disabled='readonly'>
                                                            </td>
                                                        </tr>
                                                        <tr> 
                                                        <th class="align-middle"> Prénom <span v-show='required.firstname&&!readonly' class="text-danger" >*</span></th> 
                                                        <td v-if="readonly" class="align-middle">{{this.firstname}}</td> 
                                                        <td v-else class="align-middle"> <input v-model="firstname" type="text" name="Prénom" 
                                                                        @keypress="check_input($event)"
                                                                        placeholder="Entrer le prénom" 
                                                                        class="form-control border-color" 
                                                                        minlength="1" maxlength="255"
                                                                        :required='required.firstname' 
                                                                        :disabled='readonly'>
                                                        </td>
                                                    </tr> 
                                                    <tr > 
                                                        <th class="align-middle"> Adresse mail <span class="text-danger" v-show="!readonly">*</span></th> 
                                                        <td v-if="readonly"  class="align-middle" >
                                                            <b-row >
                                                                <b-col class="m-auto" :title="emailStatus(status).title">
                                                                    {{this.email}}  <i :class="emailStatus(status).class" > </i>
                                                                </b-col>
                                                                <b-col  cols="2" class="" v-show="status==0" >
                                                                        <b-button class="m-auto p-1" @click="validerEmail()"> Valider </b-button>
                                                                </b-col>
                                                            </b-row>
                                                        </td> 
                                                        <td v-else  class="align-middle"> <input  v-model="email" type="email" placeholder="Entrer son email" class="form-control border-color"  pattern="[^@\s]+@[^@\s]+\.[^@\s]+" size="30" 
                                                                        required 
                                                                        :disabled='readonly'
                                                                        :class="emailexist? 'border border-danger' : ''">
                                                        </td>
                                                    </tr>
                                                    <tr> 
                                                        <th class="align-middle"> Téléphone <span v-show="required.tel&&!readonly"  class="text-danger">*</span> </th> 
                                                        <td v-if="readonly"  class="align-middle"> {{this.tel}}</td> 
                                                        <td v-else  class="align-middle"><input v-model="tel" 
                                                                        type="tel" name="Télephone fixe"
                                                                        @keypress="check_phone_number($event)"
                                                                        placeholder="Entrer son numéro fixe" 
                                                                        class="form-control border-color"
                                                                        minlength="10" maxlength="30"
                                                                        :required="required.tel"
                                                                        :disabled='readonly'>
                                                        </td>
                                                    </tr>
                                                    <tr> 
                                                    <th class="align-middle"> Mobile  <span v-show="required.mobile&&!readonly"  class="text-danger" >*</span></th> 
                                                        <td v-if="readonly"  class="align-middle"> {{this.mobile}}</td> 
                                                        <td v-else  class="align-middle"><input v-model="mobile"
                                                                        type="tel" name="Télephone mobile"
                                                                        @keypress="check_phone_number($event)"
                                                                        placeholder="Entrer son numéro mobile" 
                                                                        class="form-control border-color"
                                                                        minlength="10" maxlength="30"
                                                                        :required="required.mobile"
                                                                        :disabled='readonly'>
                                                        </td>
                                                    </tr>
                                                    <tr v-if='!readonly'>
                                                        <td colspan="2">
                                                            <div class="text-right mrg-top-5" >
                                                                <button class="btn btn-default mr-3" @click="Cancel()" :disabled="isBusy">Annuler</button>
                                                                <b-button variant="primary" disabled v-if="isBusy">
                                                                    <b-spinner small></b-spinner>
                                                                    Modifier...
                                                                </b-button>
                                                                <b-button v-else type="submit" class="btn btn-primary"> Modifier </b-button>
                                                            <!-- <button type="submit" class="btn btn-primary" >Modifier</button> -->
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </form>                
                                </div>
                            </b-tab>

                    <!-- ##################################################################################################################################################################### -->       
                            <b-tab title="Changer le mot de passe" class="font-weight-bold" >
                                <div class="col-md-10 m-auto " id="password" >
                    <!-- * * * * * * * * * * * * * * * * * * * * * -->
                                <!-- <div class="row mrg-top-5">
                                        <div class="col-md-10 m-auto ">
                                            <div class="alert alert-danger text-center" role="alert" v-if="error.password">
                                                {{error.text}}
                                                <i class="ti-close float-right mt-1" @click="error.password = false"></i>
                                            </div>
                                        </div>
                                    </div> -->
                    <!-- * * * * * * * * * * * * * * * * * * * * * -->
                                    <b-alert class="col-md-10 m-auto mrg-btm-10"
                                            :show="alert.password&&alert.dismissCountDown"
                                            dismissible 
                                            :variant="error.password? 'danger': 'success'"
                                            @dismissed="[alert.dismissCountDown=0,alert.password=false, error.password=null]" 
                                            @dismiss-count-down="countDownChanged">
                                        <div class="text-center text-success m-auto " :class="error.password? 'text-danger': 'text-success'">
                                        <span class="lead">
                                            <span v-if="error.password"> {{error.text}} </span>
                                            <span v-else-if="error.password==false"> Votre mot de passe a bien été modifié.</span>
                                        </span>
                                        
                                        <br> <hr>
                                        <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                                        </div>
                                    </b-alert>
    <!--* * * * * * * * * * * * * * * * * * * * * * * * -->
                                    <form  @submit.prevent="updatePassword()">                  
                                        <b-form-group label="Votre ancien mot de passe" class="col-md-10 m-auto">
                                        <div class="input-icon form-group">
                                            <i class="fa fa-key"></i>
                                            <b-form-input  v-model="password.old" 
                                                    type="password" class="form-control" placeholder="Saisissez votre mot de passe" required  onCopy="return false"> 
                                            </b-form-input>
                                        </div>
                                        </b-form-group>                 
                                        <b-form-group :state="validateState('password')" label="Votre nouveau mot de passe" class="col-md-10 m-auto">
                                        <div class="input-icon form-group">
                                            <i class="fa fa-key"></i>
                                            <b-form-input  v-model="password.new" :state="validateState('password')"
                                                    type="password" class="form-control" placeholder="Saisissez votre nouveau mot de passe" required onCopy="return false"> 
                                            </b-form-input>
                                        </div>
                                        </b-form-group>

                                        <b-form-group :state="validateState('password')" label="Confirmez votre nouveau mot de passe" class="col-md-10 m-auto">
                                        <div class="input-icon form-group">
                                            <i class="fa fa-key"></i>
                                            <b-form-input  v-model="password.confirm" :state="validateState('password')"
                                                    type="password" class="form-control" placeholder="Confirmez votre mot de passe" required onCopy="return false" onPaste="return false"> 
                                            </b-form-input>      
                                            <b-form-invalid-feedback class="text-center font-size-13" :state="validateState('password')">{{error.text}}</b-form-invalid-feedback>
                                        </div>
                                        </b-form-group>
                                        <!-- ################################# -->
                                        <div class="row text-right mrg-top-5">
                                            <div class="col-md-10 m-auto">
                                                
                                                <button type="reset"  class="btn btn-default disabled" @click="clearPassword()" :disabled="isBusy">Annuler</button>

                                                <b-button variant="primary" disabled v-if="isBusy"> <b-spinner small></b-spinner> Modifier... </b-button>
                                                <b-button v-else type="submit" class="btn btn-primary ml-3" :class="error.password? 'disabled': ''" :disabled="error.password">Modifier</b-button>
                                            </div>
                                        </div>

                                    </form>               
                                </div>
                            </b-tab>
                    
    <!-- ##################################################################################################################################################################### -->       
                            <b-tab title="Mes Structures" class="font-weight-bold"  @click="clearPassword()">
                                <div class="col-md-12 text-right "> 
                                    <button @click="$refs.structure_popup.show()" class="btn btn-info"> Changer de Structure/Rôle </button>
                                </div>
                                <div class="col-md-12 " >
                                    <div class="row mrg-top-5">
                                        <div class="col-md-10 m-auto ">
                                            <div class="alert alert-danger" role="alert" v-if="error.structure">
                                                {{error.text}}
                                                <i class="ti-close float-right mt-1" @click="error.structure = false"></i>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="col-md-5 fixed-top m-auto mrg-top-70">
                                    <b-alert
                                        :show="alert.structure&&alert.dismissCountDown"
                                        dismissible
                                        variant="info"
                                        @dismissed="[alert.dismissCountDown=0 , alert.structure=false, structure_name='',]"
                                        @dismiss-count-down="countDownChanged">
                                        <div class="text-center m-auto text-info">
                                        <span  class="lead"> Vous êtes connecté à la structure :<br> <b>{{structure_name}}</b> </span> 
                                            <br> <hr> cette alerte disparaîtra après {{alert.dismissCountDown}} secondes </div>
                                    </b-alert>
                                    </div>                 
                                <div class="table-overflow " >
                                        <table id="dt-opt" class="table table-lg table-striped text-center font-weight-light">
                                            <thead>
                                                <tr>
                                                    <th>Structure</th>
                                                    <th>Rôle(s)</th>
                                                    <th>Adresse</th>
                                                    <th>Zone</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="struct in structuresDistinct" v-bind:key="struct.roles" >
                                                    
                                                <td class="align-middle pointer font-weight-bold" >{{struct.name}}</td>
                                                <td  class="align-middle">
                                                    <table class="table table-sm text-center table-borderless mb-0">
                                                        <tr  v-for="role in struct.list_roles" v-bind:key="role.id" class="bg-transparent">  
                                                            <td class="align-middle" v-if="role.role_id==1" colspan="2">Responsable </td> 
                                                            <td  class="align-middle" v-else-if="role.role_id==3"> 
                                                                Adhérent(e)
                                                                <span v-if='role.code==null'> - </span>
                                                                <span v-else> ( {{role.code}} ) </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td class="align-middle" >{{struct.address}} , {{struct.postal}} {{struct.city}} , {{struct.country}}</td>
                                                <td class="align-middle" > {{struct.zone}} </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                            <!-- 
    <div class="table-overflow " >
                                        <table id="dt-opt" class="table table-lg table-striped text-center font-weight-light">
                                            <thead>
                                                <tr>
                                                    <th  @click="sort('name')" v-bind:class="[sortBy === 'name' ? sortDirection : '']" class="pointer">Structure</th>
                                                    <th @click="sort('code')" v-bind:class="[sortBy === 'code' ? sortDirection : '']" class="pointer">Code Adherent</th>
                                                    <th @click="sort('role_id')" v-bind:class="[sortBy === 'role_id' ? sortDirection : '']" class="pointer">Rôle</th>
                                                    <th @click="sort('address')" v-bind:class="[sortBy === 'address' ? sortDirection : '']" class="pointer">Adresse</th>
                                                    <th @click="sort('zone')" v-bind:class="[sortBy === 'zone' ? sortDirection : '']" class="pointer">Zone</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="struct in structures" v-bind:key="struct.roles" >
                                                    
                                                <td class="align-middle pointer font-weight-bold" >{{struct.name}}</td>

                                                <td class="align-middle" v-if='struct.pivot.code==null'> - </td>
                                                <td class="align-middle" v-else> {{struct.pivot.code}} </td> 

                                                <td class="align-middle" v-if='struct.pivot.role_id==1'>Responsable</td>
                                                <td class="align-middle" v-else-if='struct.pivot.role_id==3'>Adhérent(e) </td>

                                                <td class="align-middle" >{{struct.address}} , {{struct.postal}} {{struct.city}} , {{struct.country}}</td>
                                                <td class="align-middle" > {{struct.zone}} </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div> 
                                -->
                                </div>
    <!-- ################################################################################ -->

                            </b-tab>
                            
    <!-- ##################################################################################################################################################################### -->       
                            <b-tab title="" class="font-weight-bold"  @click="clearPassword()">
                                <template slot="title" class="notifications dropdown">
                                    Mes Invitations
                                    <Nb-Invitation page="Profile"></Nb-Invitation>
                                </template>
                                <mes-invitations  @AccepterRefuser = "getProfile"> </mes-invitations>
                            </b-tab>
    <!-- ##################################################################################################################################################################### --> 
                        </b-tabs>
                    </b-overlay> 
                </b-card>
            </div>
        </div>
<!-- ##################################################################################################################################################################### -->     
        <b-modal ref="structure_popup" hide-footer hide-header centered no-close-on-backdrop>
            
            <Choisir-Structure 
                :structures="structuresDistinct"
                :email="email"
                :token="token"
                @Choisir-Structure-done= "Choisir_Structure_close"
                @Choisir-Structure-Cancel="$refs.structure_popup.hide()">
            </Choisir-Structure>
        </b-modal>
<!-- ##################################################################################################################################################################### --> 
                    
    </div>
</template>

<script>

    import api from "../config/_api";
    import { mapGetters } from 'vuex';
    import Role from "../components/Role/Role.vue";
    
    import {UPDATED_PROFILE} from '../store/actions/user';
    
    import ChoisirStructure from "../components/Choisir_Structure.vue";

    export default {
        name: "Profile",
        components : {
            'mes-invitations' : Role,
            'Choisir-Structure': ChoisirStructure},
        data () {
            return {
                loading : false,
                NbInvitation : 0,
                emailexist : false ,
                alreadyValid : false , 
                isBusy : false,
                user : null ,
                structures : null,
                structuresDistinct : null,
                user_id: null,
                code: "",
                title: "",
                firstname: "",
                lastname: "",
                email: "",
                token: "",
                tel: "",
                mobile: "",
                status : null,
                role_id :0,
                required : {
                    mobile : true, 
                    tel :true ,
                    firstname : true
                },
                password : {
                    old : null ,
                    new : null ,
                    confirm : null,
                } ,

                error : { // initialiser l'objet error {pour la fonction alerte}
                    profile : false,
                    validerEmail : false,
                    structure : false,
                    password : false,
                    text : ""
                },
                readonly : true,
                alert : {
                        profile : false ,
                        structure : false ,
                        password : false,
                        validerEmail : false,

                        dismissSecs: 10,
                        dismissCountDown: 0,
                },
                validation : {
                    password :{
                            $dirty : false,
                            $error : false,
                    }
                    },
                structure_name : "",
                
                sortBy :"",
                sortDirection :"asc",
            }
        },
        computed: {
            width(){
                var width=(window.innerWidth > 0) ? window.innerWidth : screen.width;
                return width;
            },
        },
        mounted() {           
            this.$store.getters['user/getProfile'];
            this.getProfile();
            this.token = this.$store.getters.getProfile.api_token;
        },
        watch :{
            tel(){  
                    var tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    var mobile = this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.tel=((tel.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    this.required.mobile=((mobile.length>=10)||((mobile.length<10)&&(tel.length<10)));
            },
            mobile(){
                    var tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    var mobile = this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.mobile=((mobile.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    this.required.tel=((tel.length>=10)||((mobile.length<10)&&(tel.length<10)));
            },
            title(){
                    this.required.firstname=(this.title=='M.' || this.title=='Mme.'  || this.title==null);
            },
          "password.new"(){
            this.cmpPassword(this.password.new,this.password.confirm);
          },
          "password.confirm"(){
            this.cmpPassword(this.password.confirm,this.password.new);
          },
        },
        methods: {  
            getProfile(){
                this.loading=true;
                 this.axios({url: api.url + 'utilisateur/' + this.$store.getters.getProfile.id , data: null, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            this.user=resp.data.user;
                            this.role_id=resp.data.user.role_id;
                            this.title= resp.data.user.title;
                            this.user_id=resp.data.user.id ;
                            this.firstname=resp.data.user.firstname;
                            this.lastname=resp.data.user.lastname;
                            this.email=resp.data.user.email;
                            this.tel=resp.data.user.tel===null ? '':resp.data.user.tel;
                            this.mobile=resp.data.user.mobile===null ? '':resp.data.user.mobile;
                            this.status=resp.data.user.status;
                            this.structures=resp.data.structures;
                            this.structuresDistinct=resp.data.structuresDistinct;
                            this.$store.dispatch(UPDATED_PROFILE,this.user); 
                        }
                        this.loading=false;
                    })
                    .catch(err => {
                        this.error = true;
                        
                        this.loading=false;
                        //console.log(err);
                    });
            },
          cmpPassword(val1,val2){
              var cmp=val1.localeCompare(val2);

              if(val1==null || val2==null || val1.length==0 || val2.length==0){
                this.validation['password'].$dirty=false;
                this.validation['password'].$error=false;
                this.error.password=null;
              }

              else if(cmp==0){
                this.validation['password'].$dirty=true;
                this.validation['password'].$error=false;
                this.error.password=false;
              }
              
              else{
                this.validation['password'].$dirty=true;
                this.validation['password'].$error=true;
                this.error.password=true;
                this.error.text="les deux mots de passe ne correspondent pas";
              }

          },
            clearPassword() {
                this.password.old = null ;
                this.password.new= "" ;
                this.password.confirm = "";
            },
            
            updatePassword(){
                this.isBusy=true;
                var data = {
                    user_id: this.user_id,
                    password_old: this.password.old,
                    password_new: this.password.new,
                    password_confirmation : this.password.confirm,
                }

                this.axios({url: api.url + 'password/update',data : data, method: 'POST' })
                .then(result => {
                    this.Succes("password");
                    
                }, error => {
                    this.Echec("password",error.response.data);
                });
            this.clearPassword();
            },
            update() {
                this.isBusy=true;
                let data = {
                    title: this.title,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    tel: this.tel,
                    mobile: this.mobile,
                    //role_id: this.role_id,
                };
                this.axios({url: api.url + 'adherents/' + this.user_id + '?structure_id=' + this.$store.getters.structure_id, data: data, method: 'PUT' })
                    .then(resp => {
                        if(resp.status <400){
                            this.Succes("profile");
                            
            this.$store.dispatch('adherents/getStructuresDistinct');
                        }
                    })
                    .catch(err => {
                        this.Echec("profile",err.response.data);
                    });
                    
            },
            check_phone_number: function(event){
                if(event.keyCode < 8 || event.keyCode > 57 || event.keyCode ==13 || event.keyCode ==33 || event.keyCode ==34|| event.keyCode ==35 || event.keyCode ==36 || event.keyCode ==37 || event.keyCode ==38 || event.keyCode ==39 || event.keyCode ==40 || event.keyCode ==41 || event.keyCode ==42 || event.keyCode ==44 || event.keyCode ==45 || event.keyCode ==46 || event.keyCode ==47) event.returnValue = false;
                if( event.which < 8 || event.which > 57 || event.which ==13 || event.which ==33 || event.which ==34 || event.which ==35 || event.which ==36 || event.which ==37 || event.which ==38 || event.which ==39 || event.which ==40 || event.which ==41 || event.which ==42 || event.which ==44 || event.which ==45 || event.which ==46 || event.which ==47) return false;
            },
            check_input: function(event){
                if( event.keyCode < 8 ||  event.keyCode > 122 || event.keyCode==13 || event.keyCode==33 || event.keyCode==34 || event.keyCode==35 || event.keyCode==36 || event.keyCode==37 || event.keyCode==38 || event.keyCode==39 || event.keyCode==40 || event.keyCode==41 || event.keyCode==42 || event.keyCode==43 || event.keyCode==44 || event.keyCode==46 || event.keyCode==47 || event.keyCode==58 || event.keyCode==59 || event.keyCode==60 || event.keyCode==61 || event.keyCode==62 || event.keyCode==63 || event.keyCode==64 || event.keyCode==91 || event.keyCode==92 || event.keyCode==93 || event.keyCode==94 || event.keyCode==96) event.returnValue = false;
                if( event.which < 8 ||  event.which > 122  || event.which==13 || event.which==33 || event.which==34 || event.which==35 || event.which==36 || event.which==37 || event.which==38 || event.which==39 || event.which==40 || event.which==41 || event.which==42 || event.which==43 || event.which==44|| event.which==46 ||  event.which==47 ||  event.which==58 ||  event.which==59 ||  event.which==60 ||  event.which==61 ||  event.which==62 ||  event.which==63 ||  event.which==64 ||  event.which==91 ||  event.which==92 ||  event.which==93 ||  event.which==94 ||  event.which==96) return false;
            },
            Cancel(){
                this.title=this.user.title;
                this.firstname=this.user.firstname;
                this.lastname=this.user.lastname;
                this.email=this.user.email;
                this.tel=this.user.tel===null ? '':this.user.tel;
                this.mobile=this.user.mobile===null ? '':this.user.mobile;
                this.readonly=!this.readonly;
            },
            validateState(name){
                const { $dirty, $error } = this.validation[name];
                        return $dirty ? !$error : null;

          },
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
            
            Succes(name){
                if (name=="password"){
                    this.error.password=false;
                    this.alert.password=true;
                    this.showAlert();
                    this.isBusy=false;
                }
                else if (name=="profile"){
                    this.emailexist=false;
                    this.error.profile = false;
                    this.getProfile();
                    this.isBusy=false;
                    this.readonly=true;
                    this.alert.profile=true;
                    this.showAlert();
                }
                
                else if (name=="structure"){
                    this.error.structure=false;
                    this.alert.structure=true;
                    this.showAlert();
                }

                else if(name=="validerEmail"){
                    this.error.validerEmail=false;
                    this.alert.validerEmail=true;
                    this.showAlert();
                }
                this.isBusy=false;
                
            },
            Echec(name,data){
                this.error.text=data.message;
                if (name=="password"){
                    this.error.password=true;
                    //"Impossible de changer le mot de passe ! Veuillez contacter KEMTAG";
                    this.alert.password=true;
                    this.showAlert();
                }
                else if (name=="profile"){
                    this.error.profile = true;
                    this.alert.profile=true;
                    this.showAlert();
                    if(data.error==100){
                        this.emailexist=true;
                    }
                }
                
                else if (name=="structure"){
                    this.error.structure=true;
                    this.alert.structure=true;
                    this.showAlert();
                }
                else if(name=="validerEmail"){
                    this.error.validerEmail=true;
                    this.alert.validerEmail=true;
                    this.showAlert();
                }

                this.isBusy=false;
            },
            Choisir_Structure_close(struct){
              this.$refs.structure_popup.hide();
                if(struct.id==this.$store.getters.structure_id){
                    this.structure_name=struct.name;
                    this.Succes("structure");
                    this.$router.push({path:'/dashboard'});
                }
                    
            },
            sort: function(s){
                if(s === this.sortBy) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }
                this.sortBy = s;

                return this.structures.sort((p1,p2) => {
                    let modifier = 1;
                    if(this.sortDirection === 'desc') modifier = -1;
                    if(s=='code' || s=='role_id'){
                        //console.log(s);
                        if(p1['pivot'][this.sortBy]==null && p2['pivot'][this.sortBy]==null) return 0 ;
                        if(p1['pivot'][this.sortBy] < p2['pivot'][this.sortBy] || p1['pivot'][this.sortBy]!=null && p2['pivot'][this.sortBy]==null) return -1 * modifier;
                        if(p1['pivot'][this.sortBy] > p2['pivot'][this.sortBy] || p1['pivot'][this.sortBy]==null && p2['pivot'][this.sortBy]!=null) return 1 * modifier; 
                    }
                    if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier; if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                   
                    return 0;
                });
                
            },
            emailStatus(Emailstatus){
                var status={
                    title : '',
                    class : ''
                };

                if(Emailstatus==1){
                        status.class="fa fa-check text-success" ; status.title="Cette adresse mail est valide";
                }else if (Emailstatus==0){
                        status.class="fa fa-question text-dark" ;  status.title="Cette adresse mail n'a pas encore été validée";
                }else if (Emailstatus==4){
                    status.class="fa fa-hourglass-half" ; status.title="Cette adresse mail est temporaire";
                }else if(Emailstatus==2 || Emailstatus==3){
                        status.class="fa fa-times text-danger"; status.title="Cette adresse mail n'est pas valide"
                }
                return status;
            },
            validerEmail(){
                this.isBusy=true;
                
                let data ={
                    user_id : this.user_id,
                    link : api.link+"ValiderMonAdressMail",
                }
                this.axios({url: api.url + 'validerAdressMail/', data: data, method: 'POST' })
                    .then(resp => {
                        this.alreadyValid=resp.data.valide;
                        this.Succes('validerEmail');
                        
                    })
                    .catch(err => {
                        this.Echec('validerEmail');
                    });
            }
        },

    }
</script>

<style>
.border-color{
    border: 1px solid #b0bbccd7;
}
form table tr {
    height: 70px;
}
form table tr td {
    width: 70%;
}
</style>